const axios = require('axios');

import {
	serverUrl,
	presighnedUrl
} from '../properties'

const dataUrl = serverUrl;

export default {
	namespaced: true,
	state: {
		scrapperList: [],
		scrapperCount: 0,
	},
	mutations: {
		saveScrapperData: (state, data) => {
			state.scrapperList = data
		},
		updateScrapperCount: (state, data) => {
			state.scrapperCount = data
		},
	},
	getters: {
		receiveScrapperCount: (state, getters) => {
			return state.scrapperCount;
		}
	},
	actions: {
		saveNewAsin({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {

				payload.userName = JSON.parse(window.localStorage.session).name;

				let url = dataUrl + "/asinScraper/addEdit"
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error.response);
				})
			})
		},
		getPresighnedURL({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = presighnedUrl;
				let data = {
					"contentType": "text/csv",
					"ext": "csv"
				}
				let tempUrl = dataUrl + "/product/getPresignedURL"
				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: data,
					responseType: 'json'
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		uploadFile({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {

				let headers = {};

				axios({
					url: payload.url,
					method: 'PUT',
					headers: rootGetters.fetchHeader,
					data: payload.data,
					headers: { 'Content-Type': 'text/csv' },
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		updateFileData({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {

				payload.userName = JSON.parse(window.localStorage.session).name;

				//	let url = dataUrl + "/account/updateBulkData";
				let url = dataUrl + "/asinScraper/bulkAdd";

				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		getScrapperList({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}) {
			return new Promise((resolve, reject) => {

				let url = dataUrl + "/asinScraper/list";
				let vendor_name = ""
				if (rootState.selectedVendorFilter && rootState.selectedVendorFilter != 'all') {
					//let data = rootState.vendorList.find(e => e.id == rootState.selectedVendorFilter);
					vendor_name = rootState.selectedVendorFilter
				}
				let payload = {
					resultsPerPage: sessionStorage.getItem("asinScapper:showPerPage"),
					pageNumber: rootGetters.getCurrentPageNumber,
					q: rootState.searchFilterString,
					vendor_name: vendor_name,
					brand_id: rootState.selectedBrandProduct,
					sort: rootState.selectedSortOrder
				}
				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {
					console.log(response.data);
					resolve(response.data.data)
					commit("saveScrapperData", response.data.data);
					commit('updateScrapperCount', response.data.count)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		getAsinDownloadUrl({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}) {
			return new Promise((resolve, reject) => {
				debugger
				let url = dataUrl + "/asinScraper/export";
				let vendor_name = ""
				if (rootState.selectedVendorFilter && rootState.selectedVendorFilter != 'all') {
					//let data = rootState.vendorList.find(e => e.id == rootState.selectedVendorFilter);
					vendor_name = rootState.selectedVendorFilter
				}
				let payload = {
					resultsPerPage: sessionStorage.getItem("asinScapper:showPerPage"),
					pageNumber: rootGetters.getCurrentPageNumber,
					q: rootState.searchFilterString,
					vendor_name: vendor_name,
					brand_id: rootState.selectedBrandProduct,
					sort: rootState.selectedSortOrder
				}
				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		updateFileData({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {

				let url = dataUrl + "/asinScraper/bulkAdd";
				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		deleteProducts({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {

				let url = dataUrl + "/asinScraper/del";
				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
	}
}
